<template>
  <div>
    <LoadingOverlay
      :hasBlur="false"
      isLight
      :visible="showLoader"
    />
    <div v-if="showDetails">
      <AndroidDeviceDetailsInfo
        :androidDeviceName="androidDeviceName"
      />
      <div
        v-for="(row, index) in fields"
        :key="index"
      >
        <div :class="$style.grid">
          <AndroidDeviceSectionInfo
            v-if="row[0].value"
            :detailsInfo="row[0].value"
            :headerTitle="row[0].label"
          />
          <AndroidDeviceSectionInfo
            v-if="row.length === 2 && row[1].value"
            :detailsInfo="row[1].value"
            :headerTitle="row[1].label"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { LoadingOverlay } from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import AndroidDeviceDetailsInfo from 'client/systems/AndroidDeviceDetailsInfo.vue';
import AndroidDeviceSectionInfo from 'client/systems/AndroidDeviceSectionInfo.vue';

const googleModule = StoreModuleMap[ItemTypeConsts.mdmGoogle];

export default {
  name: 'AndroidDeviceDetails',
  components: {
    AndroidDeviceDetailsInfo,
    AndroidDeviceSectionInfo,
    LoadingOverlay,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    androidDeviceName: '',
    fields: [],
    showDetails: false,
    showLoader: true,
  }),

  mounted() {
    this.fetchAndroidDeviceDetails();
  },

  methods: {
    ...mapActions(googleModule, [
      'getDeviceDetails',
    ]),
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
    ]),

    async fetchAndroidDeviceDetails() {
      try {
        const deviceDetailsRsp = await this.getDeviceDetails(
          this.item.mdm.internal.deviceId,
        );
        if (deviceDetailsRsp.name.includes('/')) {
          const nameSplitList = deviceDetailsRsp.name.split('/');
          this.androidDeviceName = nameSplitList[nameSplitList.length - 1];
        } else {
          this.androidDeviceName = deviceDetailsRsp.name;
        }
        const {
          hardwareInfo,
          softwareInfo,
          networkInfo,
          memoryInfo,
          hardwareStatus,
          powerManagementInfo,
          displayInfo,
        } = deviceDetailsRsp.deviceInformation;

        this.fields = [
          [
            { value: softwareInfo, label: 'Software Info' },
            { value: hardwareInfo, label: 'Hardware Info' },
          ],
          [
            { value: networkInfo, label: 'Network Info' },
            { value: memoryInfo, label: 'Memory Info' },
          ],
          [
            { value: hardwareStatus, label: 'Hardware Status' },
            { value: powerManagementInfo, label: 'Power Management' },
          ],
          [
            { value: displayInfo, label: 'Display' },
          ],
        ];
        this.showLoader = false;
        this.showDetails = true;
      } catch (err) {
        this.triggerErrorNotification({
          title: 'Error',
          message: 'Unable to fetch device details.',
        });
        this.showLoader = false;
      }
    },
  },
};
</script>

<style module>
.grid {
  display: grid;
  grid-gap: var(--jc-spacer);
  grid-template-columns: 50% 50%;
  margin-right: var(--jc-spacer);
  margin-top: var(--jc-spacer);
}
</style>
